export default {
  // 关系管理
  Relationship: {
    meta: {
      title: '关系管理'
    }
  },
  // 饮水情况
  DrinkInfo: {
    meta: {
      title: '饮水情况'
    }
  }
}
